export default __webpack_public_path__ + "static/wag_dog-125bc6b16f26e18daee15d9781a4aeb9.png";